// src/App.js
import React, { useMemo, useState, useEffect, createContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline, useMediaQuery } from "@mui/material";
import { makeTheme } from "./theme";

import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import UsersPage from "./pages/UsersPage";
import AdminChatPage from "./pages/AdminChatPage";

// Κάνουμε export για να το χρησιμοποιήσουμε στην AdminNavBar
export const ColorModeContext = createContext({ mode: "light", toggleColorMode: () => {} });

export default function App() {
  const [token, setToken] = useState(localStorage.getItem("admin_token") || "");

  // --- THEME MODE (light/dark) με αποθήκευση και system preference ---
  const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");
  const [mode, setMode] = useState(() => localStorage.getItem("themeMode") || (prefersDark ? "dark" : "light"));

  useEffect(() => {
    localStorage.setItem("themeMode", mode);
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => setMode((m) => (m === "light" ? "dark" : "light")),
    }),
    [mode]
  );

  const theme = useMemo(() => makeTheme(mode), [mode]);

  const handleLogin = (tk) => {
    setToken(tk);
    localStorage.setItem("admin_token", tk);
  };

  const handleLogout = () => {
    setToken("");
    localStorage.removeItem("admin_token");
  };

  const ProtectedRoute = ({ children }) =>
    token ? children : <Navigate to="/login" replace />;

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route
              path="/login"
              element={
                token ? <Navigate to="/dashboard" replace /> : <LoginPage onLogin={handleLogin} />
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage token={token} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <UsersPage token={token} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-chat"
              element={
                <ProtectedRoute>
                  <AdminChatPage token={token} onLogout={handleLogout} />
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={token ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />}
            />
          </Routes>
        </Router>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
